import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import store from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import overscroll from "./utils/mobile-scroll-disabler";

overscroll(document.getElementById("root"));

if (
  !!window.location.hash
    .split("/")
    .find((str) => str === "show-back-button" || str === "share")
) {
  document.body.classList.add("at-enabled");
}

store.dispatch({ type: "app/init" });

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
